/* eslint-disable no-unused-vars */
// ESLint is showing errors for the DATA_TYPE enum as unused variables in this file

import {
  FilterOptionMatchStrategy,
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from './filter-selected-value.interface';

export interface FilterCollection {
  [key: string]: Filter;
}

export interface FilterOptionCollection {
  [key: string]: FilterOptions;
}
export interface FilterOptions {
  id: string;
  options: FilterOptionSelectedValue[];
}

export interface Filter {
  id: string;
  name: string;
  storeKey: string;
  selectedValue: FilterSelectedValue;
  defaultSelectedValue: FilterSelectedValue;
  type: FILTER_TYPES;
  required: boolean;
  order: number;
  error?: { errorMessage: string };
  tags?: string[];
}

export interface FilterOptionValue extends FilterOptionSelectedValue {
  attributes?: Record<string, FilterSelectedValue>;
  attributesMatchStrategy?: Record<string, FilterOptionMatchStrategy>;
}

export enum FILTER_TYPES {
  DATE_RANGE = 'DATE_RANGE',
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE',
  ASYNC_MULTIPLE = 'ASYNC_MULTIPLE',
  ASYNC_SINGLE = 'ASYNC_SINGLE',
}
